
<div [class.vertical]="isVertical" [class.horizontal]="!isVertical" class="spash">
  <mat-spinner [diameter]="80" [strokeWidth]="3"  class="custom-spinner"></mat-spinner>
  <img src="assets/{{client}}/logo.svg" width="300" class="logomainspash"/>

  <app-laterreta-splashscreen *ngIf="componentLoading == 'app-laterreta-splashscreen'"></app-laterreta-splashscreen>
  <app-barmitierra-splashscreen *ngIf="componentLoading == 'app-barmitierra-splashscreen'"></app-barmitierra-splashscreen>

</div>
